import request, { requestStream } from "@/utils/tycom-request";

const serviceName = import.meta.env.VITE_SERVICE_NAME || "ai_writer_service";

// 获取稿件类别列表
export function articleCategoryList(params) {
  return request({
    url: "/article_category/list",
    method: "get",
    params,
    serviceName,
  });
}

// 获取稿件类型列表
export function articleTypeList(params) {
  return request({
    url: "/article_type/list",
    method: "get",
    params,
    serviceName,
  });
}

/**
 * 通过code获取提示的变量列表
 * @param data
 * @returns {Promise<*|undefined>}
 */
export function getPromptByCode(data) {
  return request({
    url: "/user/ai/getPromptByCode",
    method: "post",
    data,
    serviceName,
  });
}

/**
 * 获取提示
 * @param data
 * @returns {Promise<*|undefined>}
 */
export function getPrompt(data) {
  return request({
    url: "/user/ai/getPrompt",
    method: "post",
    data,
    serviceName,
  });
}

// 查询稿件分页
export function articlePage(data) {
  return request({
    url: "/user/article/page",
    method: "post",
    data,
    serviceName,
  });
}

// AI - 通过code获取提示的变量列表
export function aiGetPromptByCode(data) {
  return request({
    url: "/user/ai/getPromptByCode",
    method: "post",
    data,
    serviceName,
  });
}

// AI - 生成结果
export function genResultByCode(data) {
  return request({
    url: "/user/ai/genResultByCode",
    method: "post",
    data,
    serviceName,
    timeout: 1000 * 60 * 5,
  });
}

// AI - 生成结果
export function aiGenResultByCode(data) {
  return request({
    url: "/user/ai/genResultByCode",
    method: "post",
    data,
    serviceName,
  });
}

// 获取提示结果
export function promptGenResult(data, config) {
  return request({
    url: "/user/ai/genResultByCode",
    method: "post",
    data,
    serviceName,
    timeout: 1000 * 60 * 5,
    ...config,
  });
}

export function addArticle(data) {
  return request({
    url: "/user/article/add",
    method: "post",
    data,
    serviceName,
  });
}

export function deleteByIdArticle(data) {
  return request({
    url: "/user/article/deleteById",
    method: "post",
    data,
    serviceName,
  });
}

export function updateByIdArticle(data) {
  return request({
    url: "/user/article/updateById",
    method: "post",
    data,
    serviceName,
  });
}

export function getByIdArticle(data) {
  return request({
    url: "/user/article/getById",
    method: "post",
    data,
    serviceName,
  });
}

/**
 * 流式返回提示结果，返回的controller可以调用abort方法中止
 * @param data       接口参数
 * @param onRole     返回角色数据
 * @param onContent  返回最新的结果数据
 * @returns {{controller: AbortController, promise: Promise<unknown>}}
 */
export function genResult({ data, onRole = () => {}, onContent = () => {} }) {
  const controller = new AbortController();
  const result = {
    content: "",
  };
  const promise = new Promise((resolve, reject) => {
    requestStream({
      url: "/user/ai/genResultByCode",
      serviceName,
      data,
      signal: controller.signal,
      onmessage(msg) {
        if (msg.data === "[DONE]") {
          resolve(result);
          return;
        }
        const text = msg.data;
        try {
          const json = JSON.parse(text);
          const content = json.choices[0].delta.content;
          if (json.choices?.[0].delta?.role) {
            result.role = json.choices[0].delta.role;
            onRole(result.role);
          }
          if (content) {
            result.content += content;
            onContent(result.content);
          }
        } catch (e) {
          console.error("[Request] parse error", e, text, msg);
        }
      },
    })
      .then(() => {
        //
      })
      .catch((err) => {
        reject(err);
      });
  });
  return { controller, promise };
}

export function getDragOriginWhitelist(data) {
  return request({
    url: "/user/getDragOriginWhitelist",
    method: "post",
    data,
    serviceName,
  });
}
